var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseModalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1984 9.2111L16.8155 3.59253C17.4814 2.9265 17.4814 1.8506 16.8155 1.18457C16.1497 0.518539 15.074 0.518539 14.4082 1.18457L8.791 6.80314L3.17383 1.16749C2.50797 0.501461 1.43234 0.501461 0.766472 1.16749C0.100607 1.83352 0.100607 2.90942 0.766472 3.57545L6.38364 9.2111L0.749399 14.8297C0.0835337 15.4957 0.0835337 16.5716 0.749399 17.2376C1.09087 17.5792 1.5177 17.75 1.96161 17.75C2.40552 17.75 2.83236 17.5792 3.17383 17.2547L8.791 11.6191L14.4082 17.2376C14.7496 17.5792 15.1765 17.75 15.6204 17.75C16.0643 17.75 16.4911 17.5792 16.8326 17.2547C17.4985 16.5887 17.4985 15.5128 16.8326 14.8468L11.1984 9.2111Z",
    fill: "#003471"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/close-modal-icon.58c3adb17380c965356fc918051cbecf.svg";
export { ForwardRef as ReactComponent };